<template>
  <div>
    <ButtonTemplateMicInput text-button="전체음소거" @click="muteAll">
      <template #icon-handler>
        <IconMicOff />
      </template>
    </ButtonTemplateMicInput>
  </div>
</template>

<script setup lang="ts">
import ButtonTemplateMicInput from '@/components/domains/chat/common/ButtonTemplateMicInput.vue';
import IconMicOff from '@/components/icons/IconMicOff.vue';
import { useMicrophonesStore } from '@/stores/microphones';

const microphones = useMicrophonesStore();

const muteAll = () => {
  microphones.stopMics(microphones.selectedMicrophoneIds);
};
</script>

<style scoped lang="scss"></style>
